import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import Amplify, { API, Auth } from "aws-amplify";
import Button from 'react-bootstrap/Button';
import {ButtonWithSound} from '../Button/Button';
import './Share.scss';
import touch from './../Button/touch_button.mp3';


const Share = (props) => {

    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const dispatch = useDispatch();

    const [coins, setCoins] = useState(props.sharedCoin);
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    function sleep(ms) {return new Promise((resolve) => setTimeout(resolve, ms));}


    const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');

    const validateUsername = (name) => {
        const regex = /^[a-zA-Z0-9]{3,25}$/; // Validates length and allowed characters
        return regex.test(name);
    };

    const handleChange = ({ target }) => {
        if (target.name === 'username') {
            setUsername(target.value)
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            submit();
        }
    }

    const submit = async () => {
        const sound = new Audio(touch);
        sound.play();
        await sleep(500); // 500ms delay before executing onClick actions
        if (validateUsername(username)) {
            setError('');
            const payload = {
                body: {
                    id: login.studentid,
                    schoolid: login.schoolid,
                    username: username,
                    coin: coins,
                },
            }
            await API.put('TIR', '/v3/student/freeplay/level2/coin', payload)
            .then((response) => {
                props.checkCompletion();
                props.setDisplayShare(false);
            })
            .catch((error) => {
                setError(error.response.data.message)
            });
        } else {
            setError('Username must be 3-25 characters and can only contain letters, numbers, underscores, and dashes.');
        }
    }


    return (
        <div className='shareBody'>
            <div className='shareHeader'>
                <h1 className="title">Congratulations!</h1>
                <p className="subtitle">YOU AND YOUR FRIEND EARNED A TOTAL OF {coins} POINTS!</p>
            </div>
            <div className='coinHolder'>
                <img alt='coin' className='center'src={coinPick}/>
                <h1 className='center'>{coins}</h1>
            </div>
            <div className='username-form'>
                <h4>Add your friend’s “We Are Friends” username to add points to their account if they’ve completed World 1.</h4>
                <input
                    className='login-form__input'
                    type='Username'
                    name='username'
                    placeholder='Username'
                    value={username}
                    onChange={handleChange}
                    autoComplete='new-password'
                    onKeyDown={handleKeyDown}
                />
                {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                <div className='login-form-actions'>
                    <Button
                        className='login-form-btn__login'
                        variant='warning'
                        onClick={submit}
                    >
                        SUBMIT
                    </Button>
                </div>
            </div>
            <h4>Or click the next button if your friend doesn't have an account</h4>
        </div>
    );
};
export default Share;